import { useCreateMachine } from 'fsm';
import { machine } from './machine';
import { DataTestContext } from './context';
import { useCurrentUser } from 'policy-lib';
import { usePanelAlerts } from '../../Panel/usePanelAlerts';
import { jsx as _jsx } from "react/jsx-runtime";
export const DataTestProvider = ({
  children,
  onClose,
  onEnrichmentStart,
  objectTypeId,
  selectionIds
}) => {
  const currentUser = useCurrentUser();
  const {
    onError,
    onSuccessDataTest
  } = usePanelAlerts({
    objectTypeId: objectTypeId
  });
  const initialContext = {
    enrichAssociations: false,
    objectTypeId: objectTypeId,
    onClose,
    onEnrichmentStart,
    onError,
    onSuccess: onSuccessDataTest,
    selectionIds,
    shouldOverwrite: true
  };
  const dataTestMachine = useCreateMachine(machine, {
    initialContext,
    isReady: currentUser.isLoaded
  });
  return /*#__PURE__*/_jsx(DataTestContext.Provider, {
    value: dataTestMachine,
    children: children
  });
};